module.exports = __webpack_public_path__ + "static/margo_ovsiienko-49fcf148433377a84b88c94d9e9de2ef.png";